import Modal from "../components/main/Modal";
import Input from "../components/element/Input";
import React from "react";
import Button from "../components/element/Button";
import EntityApi from "../api/EntityApi";

type params = {
    isOpen: boolean,
    onClose: () => void,
    onSuccess?: () => void,
    parentId: number
}

const ContentModal = ({onSuccess, parentId}: {onSuccess: () => void, parentId: number}) => {

    const [categoryName, setCategoryName] = React.useState('');

    const add = () => {
        if (categoryName == '') {
            alert('error');
        } else {
            EntityApi.put('private/category', {
                title: categoryName, parent: parentId
            }).then((data) => {
                onSuccess();
                setCategoryName('');
            })
        }
    }

    return <div className="w-64">
        <Input onChange={setCategoryName} placeholder={'Введите название раздела'} type={'text'} value={categoryName}/>
        <div className="mt-6"></div>
        <Button text={"Добавить"} type={'primary'} onClick={add}/>
    </div>

}

const CatalogCategoryFormModal = ({isOpen, onClose, onSuccess, parentId}: params) => {

    const onSuccessRequest = () => {
        if (onSuccess) {
            onSuccess();
        }
        onClose();
    }

    return <Modal title={"Добавить раздел"} component={<ContentModal onSuccess={onSuccessRequest} parentId={parentId} />} isOpen={isOpen} onClose={onClose}/>

}

export default CatalogCategoryFormModal;
